import { defineStore } from "pinia"
import axios from '@axios'
import decodeJwt from '@/helpers/decodeJwt'
import { useUserStore } from "@/stores/UserStore"
import { useCookies } from "vue3-cookies"
import { useMainStore } from "@/stores/MainStore"

export const useAuthStore = defineStore("authStore", {
  state: () => {
    return {
      currentUserID: '',
      userType: undefined,
      errors: {
        email: undefined,
        password: undefined,
      },
    }
  },
  actions: {
    // 👉 Login User
    async loginUser(email, password, ability, router, route) {
      try {
        const r = await axios.post('/api/auth/generate', {
          email: email,
          password: password,
        })

        if (r?.data?.retailer?.config) localStorage.setItem('retailerConfig', JSON.stringify(r.data.retailer.config))

        await this.saveJWTInfo(r.data.authorization.token)

        await this.updateAbility(ability)

        router.push(route.query.to ? String(route.query.to) : '/')
      } catch (e) {
        console.error(e)
      }
    },

    async updateAbility(ability) {
      const userAbilities = [{
        "action": "manage",
        "subject": "all",
      }]

      localStorage.setItem('userAbilities', JSON.stringify(userAbilities))

      return ability.update(userAbilities)
    },

    async saveJWTInfo(token) {
      const { cookies } = useCookies()

      cookies.set('jwt', token)

      const userInfoResponse = await this.getUserJwtInfo()

      if (userInfoResponse) {
        const userStore = useUserStore()
        const profileResponse = await userStore.getUserProfile()

        if (profileResponse) {
          localStorage.setItem('accountName', JSON.stringify(profileResponse.name))

          if (profileResponse.account_status) localStorage.setItem('accountStatus', JSON.stringify(profileResponse.account_status))

          if (userInfoResponse.retailer_id) {
            localStorage.setItem('retailerConfig', JSON.stringify(profileResponse.config))
          }
        }

        return userInfoResponse
      }
      else {
        cookies.remove('jwt')
      }
    },

    async getUserJwtInfo() {
      const userStore = useUserStore()
      const jwtInfo = decodeJwt()
      if (jwtInfo) {
        try {
          const userDetailsArray = await userStore.getUserDetails(jwtInfo.id)
          if (jwtInfo.retailer_id) userDetailsArray.retailer_id = jwtInfo.retailer_id
          else userDetailsArray.publisher_id = jwtInfo.publisher_id
          localStorage.setItem('userData', JSON.stringify(userDetailsArray))

          return userDetailsArray
        } catch (e) {
          console.error(e)
        }
      }
    },

    async getResetPasswordLink(email) {
      try {
        const mainStore = useMainStore()

        const response = await axios.post(`api/legacy/auth/forgot-password`, {
          email: email,
        })

        await mainStore.addMessage('success', response.data.message ? response.data.message : 'We have emailed your password reset link!')
        
        return response.data
      } catch (error) {
        console.error(error)
      }
    },

    async resetPassword(email, confirmPass, password, token) {
      try {
        const mainStore = useMainStore()

        const response = await axios.post(`api/legacy/auth/reset-password`, {
          email: email,
          token: token,
          password: password,
          password_confirmation: confirmPass,
        })

        await mainStore.addMessage('success', response.data.message ? response.data.message : 'Password changed!')
        
        return response.data
      } catch (error) {
        console.error(error)
      }
    },

    async checkToken(email, token) {
      try {
        const response = await axios.post(`api/legacy/auth/reset-password/check`, {
          email: email,
          token: token,
        })

        
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
  },
})
